import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Сайт учителя математики, г. Краснодар',
      description: 'Сайт учителя математики 36-й гимназии г. Краснодара Гайдук Янины Сергеевны'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      title: 'Обо мне | Сайт учителя математики, г. Краснодар',
      description: 'Сайт учителя математики 36-й гимназии г. Краснодара Гайдук Янины Сергеевны'
    }
  },
  {
    path: '/materials',
    name: 'materials',
    component: () => import(/* webpackChunkName: "about" */ '../views/MaterialsView.vue'),
    meta: {
      title: 'Учебные материалы | Сайт учителя математики, г. Краснодар ',
      description: 'Сайт учителя математики 36-й гимназии г. Краснодара Гайдук Янины Сергеевны'
    }
  },
  {
    path: '/contact',
    name: 'contacts',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue'),
    meta: {
      title: 'Связь со мной | Сайт учителя математики, г. Краснодар',
      description: 'Сайт учителя математики 36-й гимназии г. Краснодара Гайдук Янины Сергеевны'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // Всегда возвращаемся в начало страницы
    return { top: 0,
      behavior: 'smooth'  }
  }
})

export default router
